import { render, staticRenderFns } from "./UsuarioFormulario.vue?vue&type=template&id=4568e356&scoped=true"
import script from "./UsuarioFormulario.vue?vue&type=script&lang=js"
export * from "./UsuarioFormulario.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFormulario.vue?vue&type=style&index=0&id=4568e356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568e356",
  null
  
)

export default component.exports